import React, { Component } from "react";
import {Redirect, Route} from "react-router-dom";
import { inject, observer } from "mobx-react";
import {ToastContainer} from "react-toastify";
import {http} from "./config/Constantes";
import {Login} from "./modules/login/tela/Login";
import MeuTecon from "./modules/meutecon/telas/MeuTecon";
import {arrayIsEmpty} from "./utils/functions";
import ConfigurableModalContainer from "./modules/comum/modal/components/ConfigurableModalContainer";

@inject("store")
@inject("routes")
@observer
export default class App extends Component {
	constructor(props) {
		super(props);
		this.store = this.props.store;
        this.routes = this.props.routes;
        this.loginStore = this.props.store.loginStore;
        this.appStore = this.props.store.appStore;
    }

	componentDidMount() {
        this.loginStore.isLogado = true;        
        this.loginStore.getUsuarioMenus();
	}

    componentWillMount() {
        if (window.location.pathname == "/triagem-depot") {
            window.localStorage.setItem('nextPage', "/triagem-depot")
        }
        this.appStore.setCurrentPage(this.props.location.pathname);
    }

	componentWillReceiveProps(props) {
		if(this.appStore.currentPage != null && this.appStore.currentPage !== props.location.pathname) {
            http.cancel(this.appStore.currentPage);
		}

        this.appStore.setCurrentPage(props.location.pathname);
    }
    
    validaAcesso = (opcao) => {
        let result = false;

        if (!arrayIsEmpty(this.loginStore.permissoes)) 
        {
            result = this.loginStore.permissoes.includes(opcao);
        }
        
       return result;
    }

	render() {
        const routesList = [];
        let key = 0;        
        routesList.push(<Route
                            key={key}
                            exact
                            path="/meu-tecon"
                            component={MeuTecon}
                        />)
        key++;

        for (let i=0; i < this.routes.length; i++) {
            const menuCategory = this.routes[i];
                if(typeof menuCategory.itens !== 'undefined'){
                    for (let j=0; j < menuCategory.itens.length; j++) {
                        const menuCategoryItem = menuCategory.itens[j];
                        let menuItem = this.validaAcesso(menuCategoryItem.tag); // Verifica se está na lista de permissões do usuário
                        if (menuItem || !menuCategory.needLogin)
                        {
                            const tag = process.env.rig ? "AgendamentoCntr" : "Consultas";

                            if (menuCategory.tag === tag && 
                                menuCategoryItem.label!=undefined &&
                                menuCategoryItem.label.toUpperCase() === "NOTAS FISCAIS") {
                                    // console.log("no action");
                                } else {
                                routesList.push(
                                <Route
                                    key={key}
                                    exact
                                    path={menuCategoryItem.path}
                                    component={menuCategoryItem.component}
                                />);
                                key++;
                            }
                        }
                    }
                }
        }

		return (
			<div>
                <div>
                    {this.appStore.check() && <Redirect to="/login" component={<Login />}/>}
                    {/* {!this.appStore.check() && <Redirect from='*' to='/'/>}  */}
                    {routesList}
                    <ConfigurableModalContainer />
                    <ToastContainer
                        position="top-right"
                        type="success"
                        autoClose={5000}
                        className="custom-toast"
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick={false}
                        pauseOnHover
                    />
                </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App.js